export const AMOUNT_FIELD_NAME = 'amount';
export const CREDITCARD_CATEGORY_NAME = 'creditcard';
export const FIAT_AMOUNT = 'fiatAmount';
